import React from 'react';

import Error from '@xingternal/pages-warning';
import Skeleton from './Skeleton';
import Gallery from './Gallery';

import { useAboutUsSubpageMediaQuery } from './MediaQuery.gql-types';

const NUMBER_MEDIA_ITEMS = 100;

type GalleryContainerProps = {
  pageSlug: string;
  itemClicked: number | null;
};

const GalleryContainer = ({ pageSlug, itemClicked }: GalleryContainerProps) => {
  const { data, loading, refetch } = useAboutUsSubpageMediaQuery({
    variables: {
      id: pageSlug,
      first: NUMBER_MEDIA_ITEMS,
    },
    notifyOnNetworkStatusChange: true,
  });

  const galleryItemNodes =
    data?.pagesAboutUs?.__typename === 'AboutEntity' &&
    data?.pagesAboutUs?.media?.__typename === 'EntityMediaConnection' &&
    data?.pagesAboutUs?.media?.edges;

  const galleryItems = galleryItemNodes ? (galleryItemNodes.map(item => item!.node)) : undefined;

  const hasError = !galleryItems || galleryItems.length === 0 || galleryItems === null;

  return (
    <>
      {loading && <Skeleton />}
      {hasError && !loading && (
        <Error
          headerText="EP_ERROR_HEADER"
          bodyText="EP_ERROR_BODY"
          buttonText="EP_ERROR_RELOAD_CTA"
          onClick={() => refetch()}
        />
      )}
      {data && !loading && !hasError && galleryItems && (
        <Gallery itemClicked={itemClicked} galleryItems={galleryItems} />
      )}
    </>
  );
};

export default GalleryContainer;
